/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOverwolfGameBodySeo
 */
export interface CreateOverwolfGameBodySeo {
    /**
     * 
     * @type {boolean}
     * @memberof CreateOverwolfGameBodySeo
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    metaTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    metaDescription?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBodySeo
     */
    keywords?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    ogTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    ogDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    ogImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    twitterCard?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    twitterTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    twitterDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBodySeo
     */
    twitterImage?: string;
}

/**
 * Check if a given object implements the CreateOverwolfGameBodySeo interface.
 */
export function instanceOfCreateOverwolfGameBodySeo(value: object): value is CreateOverwolfGameBodySeo {
    return true;
}

export function CreateOverwolfGameBodySeoFromJSON(json: any): CreateOverwolfGameBodySeo {
    return CreateOverwolfGameBodySeoFromJSONTyped(json, false);
}

export function CreateOverwolfGameBodySeoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOverwolfGameBodySeo {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'metaTitle': json['metaTitle'] == null ? undefined : json['metaTitle'],
        'metaDescription': json['metaDescription'] == null ? undefined : json['metaDescription'],
        'keywords': json['keywords'] == null ? undefined : json['keywords'],
        'ogTitle': json['ogTitle'] == null ? undefined : json['ogTitle'],
        'ogDescription': json['ogDescription'] == null ? undefined : json['ogDescription'],
        'ogImage': json['ogImage'] == null ? undefined : json['ogImage'],
        'twitterCard': json['twitterCard'] == null ? undefined : json['twitterCard'],
        'twitterTitle': json['twitterTitle'] == null ? undefined : json['twitterTitle'],
        'twitterDescription': json['twitterDescription'] == null ? undefined : json['twitterDescription'],
        'twitterImage': json['twitterImage'] == null ? undefined : json['twitterImage'],
    };
}

export function CreateOverwolfGameBodySeoToJSON(json: any): CreateOverwolfGameBodySeo {
    return CreateOverwolfGameBodySeoToJSONTyped(json, false);
}

export function CreateOverwolfGameBodySeoToJSONTyped(value?: CreateOverwolfGameBodySeo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'metaTitle': value['metaTitle'],
        'metaDescription': value['metaDescription'],
        'keywords': value['keywords'],
        'ogTitle': value['ogTitle'],
        'ogDescription': value['ogDescription'],
        'ogImage': value['ogImage'],
        'twitterCard': value['twitterCard'],
        'twitterTitle': value['twitterTitle'],
        'twitterDescription': value['twitterDescription'],
        'twitterImage': value['twitterImage'],
    };
}

